/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


export { academy_courseStatus_completed } from "./en-US.js"

export { academy_courseStatus_inProgress_endingText } from "./en-US.js"

export { academy_courseStatus_inProgress_startingText } from "./en-US.js"

export { academy_courseStatus_registered } from "./en-US.js"

export { academy_courseStatus_viewed } from "./en-US.js"

export { academy_globalHead_bestPractices } from "./en-US.js"

export { academy_globalHead_collection } from "./en-US.js"

export { academy_globalHead_course } from "./en-US.js"

export { academy_globalHead_lesson } from "./en-US.js"

export { academy_globalHead_metaDesc } from "./en-US.js"

export { academy_globalHead_opengraphSiteName } from "./en-US.js"

export { academy_globalHead_search } from "./en-US.js"

export { academy_globalHead_title } from "./en-US.js"

export { academy_pages_404_button_href } from "./en-US.js"

export { academy_pages_404_button_label } from "./en-US.js"

export { academy_pages_404_titleText } from "./en-US.js"

export { academy_pages_home_hero_button_href } from "./en-US.js"

export { academy_pages_home_hero_button_label } from "./en-US.js"

export { academy_pages_home_hero_headline } from "./en-US.js"

export { academy_pages_home_hero_subhead } from "./en-US.js"

export { academy_pages_home_learn_headline } from "./en-US.js"

export { academy_pages_home_learn_row1_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row1_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row1_content } from "./en-US.js"

export { academy_pages_home_learn_row1_title } from "./en-US.js"

export { academy_pages_home_learn_row2_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row2_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row2_content } from "./en-US.js"

export { academy_pages_home_learn_row2_title } from "./en-US.js"

export { academy_pages_home_learn_row3_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row3_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row3_content } from "./en-US.js"

export { academy_pages_home_learn_row3_title } from "./en-US.js"

export { academy_pages_home_learn_row4_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row4_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row4_content } from "./en-US.js"

export { academy_pages_home_learn_row4_title } from "./en-US.js"

export { academy_pages_home_learn_row5_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row5_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row5_content } from "./en-US.js"

export { academy_pages_home_learn_row5_title } from "./en-US.js"

export { academy_pages_home_learn_row6_buttons_href } from "./en-US.js"

export { academy_pages_home_learn_row6_buttons_label } from "./en-US.js"

export { academy_pages_home_learn_row6_content } from "./en-US.js"

export { academy_pages_home_learn_row6_title } from "./en-US.js"

export { academy_pages_home_learn_subhead } from "./en-US.js"

export { academy_pages_home_liveTraining_button_href } from "./en-US.js"

export { academy_pages_home_liveTraining_button_label } from "./en-US.js"

export { academy_pages_home_liveTraining_subhead } from "./en-US.js"

export { academy_pages_home_liveTraining_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training1_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training2_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training3_title } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_description } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_href } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_metadata } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_pill } from "./en-US.js"

export { academy_pages_home_liveTraining_training4_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_button_href } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_button_label } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_excerpt } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_first_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_button_href } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_button_label } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_excerpt } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_second_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_button_href } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_button_label } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_excerpt } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_cards_third_title } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_headline } from "./en-US.js"

export { academy_pages_home_newAndNoteworthy_subhead } from "./en-US.js"

export { academy_pages_home_start_loggedIn_button_href } from "./en-US.js"

export { academy_pages_home_start_loggedIn_button_label } from "./en-US.js"

export { academy_pages_home_start_loggedIn_collectionPath } from "./en-US.js"

export { academy_pages_home_start_loggedIn_coursePath } from "./en-US.js"

export { academy_pages_home_start_loggedIn_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_button_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_button_label } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start1_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start2_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start3_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_description } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_divider } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_href } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_metadata } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_pill } from "./en-US.js"

export { academy_pages_home_start_loggedOut_start4_title } from "./en-US.js"

export { academy_pages_home_start_loggedOut_title } from "./en-US.js"

export { academy_pages_home_testimonials_headline } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote1_text } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote2_text } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote3_text } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_button_href } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_button_label } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_size } from "./en-US.js"

export { academy_pages_home_testimonials_quote4_text } from "./en-US.js"

export { alertBar_dismiss } from "./en-US.js"

export { atoms_singleLineForm_error } from "./en-US.js"

export { atoms_singleLineForm_placeholderText } from "./en-US.js"

export { atoms_singleLineForm_primaryButton } from "./en-US.js"

export { atoms_skipButton_skipContent } from "./en-US.js"

export { atoms_slideIndicator_currentSlide } from "./en-US.js"

export { atoms_slideIndicator_goToSlide } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_blog = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_home = () => `Home`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_searchAll = () => `Alles doorzoeken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_sitemap = () => `Sitemap`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_general = () => `Opmerking`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_requirements = () => `Vereisten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_warning = () => `Waarschuwing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_name = () => `Uitgelichte hulpbronnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_slug = () => `/hc/en-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_account = () => `Verzoek om toegang tot account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_article = () => `Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_category = () => `Categorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_metaDesc = () => `Zoek in ons kenniscentrum om antwoorden te vinden op veelgestelde vragen. Blader door onze artikelen, het communityforum, live en opgenomen trainingen en andere hulpbronnen om alles te leren over het gebruik van Klaviyo en om onze best practices te ontdekken.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_opengraphSiteName = () => `Klaviyo Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_search = () => `Zoeken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_section = () => `Gedeelte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_title = () => `Klaviyo Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_moreCardHeadline = () => `Ontdek meer van Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_searchHeadline = () => `Wat zoek je vandaag?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_href = () => `/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_label = () => `Naar het helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_titleText = () => `Niet gevonden | Klaviyo Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_siteName = () => `Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_category_topArticles = () => `Topartikelen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_headline = () => `Uitgelichte hulpbronnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_subhead = () => `Ontdek educatieve gidsen, cursussen en materialen om je bedrijf te laten groeien met Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL20R80_headline = () => `Zoeken op onderwerp`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL30R70_headline = () => `Zoeken op onderwerp`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsInstantSearch = () => `Geen resultaten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperSuggestion = () => `Probeer een andere zoekopdracht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperText = () => `Geen resultaten voor`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_academy_headline = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_community_headline = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_developers_headline = () => `Ontwikkelaars`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_helpCenter_headline = () => `Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_marketing_headline = () => `Marketinghulpbronnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_viewAll = () => `Alles bekijken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCode_languageString = () => `Dutch`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_locale = () => `nl-NL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_localeLowerCase = () => `nl-nl`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_pathPrefix = () => `nl`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_recaptchaLanguage = () => `nl`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_timezone = () => `Europe/Amsterdam`


export { molecule_unifiedSearchResultGridItem_nextEventDetails_upcomingDates } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_estimated = () => `Geschat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_minuteRead = () => `minuten lezen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_updated = () => `Bijgewerkt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_contactSupport = () => `Meer informatie over hoe je contact opneemt met support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_checkBoxLabel = () => `Klaviyo mag contact met me opnemen over mijn feedback.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_describe = () => `Beschrijf wat je probeert te doen, te leren of op te lossen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_errorLabel = () => `Zorg ervoor dat je e-mailadres maar één @ bevat, gevolgd door een geldig domein (naam@voorbeeld.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticle = () => `Hoe kunnen we dit artikel verbeteren?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticleSuggestion = () => `Beschrijf wat je goed vindt of hoe we het artikel kunnen verbeteren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_incompleteLabel = () => `Meer details of uitleg nodig`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_irrelevantLabel = () => `Heeft geen betrekking op wat ik zocht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_legend = () => `Bedankt voor het doorgeven! Vertel ons meer over het probleem.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_moreDetail = () => `Kun je meer details geven?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_submit = () => `Verzenden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_description = () => `We nemen alleen contact met je op over je feedback op dit artikel.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_label = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_placeholder = () => `naam@voorbeeld.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_unclearLabel = () => `Onduidelijk, verwarrend of moeilijk te begrijpen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_wrongLabel = () => `Komt niet overeen met hoe het product werkt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_furtherAssistance = () => `Gebruik dit formulier alleen voor feedback op artikelen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_headline = () => `Was dit artikel nuttig?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_no = () => `Nee`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_success = () => `Je feedback is verstuurd. Bedankt!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_thanks = () => `We zijn blij dat het geholpen heeft!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_yes = () => `Ja`


export { molecules_blogAuthor_authorAltText } from "./en-US.js"

export { molecules_blogAuthor_defaultAuthorAltText } from "./en-US.js"

export { molecules_blogAuthor_minRead } from "./en-US.js"

export { molecules_blogCard_read } from "./en-US.js"

export { molecules_countdownTimer_days } from "./en-US.js"

export { molecules_countdownTimer_hours } from "./en-US.js"

export { molecules_countdownTimer_minutes } from "./en-US.js"

export { molecules_countdownTimer_seconds } from "./en-US.js"

export { molecules_filterBlock_topic } from "./en-US.js"

export { molecules_greenhouseDepartment_openRoles } from "./en-US.js"

export { molecules_greenhouseJob_save } from "./en-US.js"

export { molecules_greenhouseJob_saved } from "./en-US.js"

export { molecules_pagination_next } from "./en-US.js"

export { molecules_pagination_previous } from "./en-US.js"

export { molecules_relatedCard_openInANewTab } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_searchBox_placeholder = () => `Zoeken op onderwerp of zoekwoord`


export { molecules_subcategoryCard_articleSingular } from "./en-US.js"

export { molecules_subcategoryCard_articlesPlural } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_countdown_d } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_countdown_h } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_countdown_m } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_countdown_now } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_day } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_days } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hour } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hours } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minute } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minutes } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartIn } from "./en-US.js"

export { molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartsNow } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_href = () => `/auth/logout`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_label = () => `Uitloggen bij Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label = () => `Mijn inloggegevens op Accredible bekijken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_href = () => `https://v2.accounts.accredible.com/retrieve-credentials`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_label = () => `Mijn inloggegevens bekijken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_label = () => `Mijn Academy-hulpbronnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_href = () => `/auth/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_label = () => `Inloggen bij Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_href = () => `https://www.klaviyo.com/contact-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_label = () => `Contact opnemen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_href = () => `https://www.klaviyo.com/dashboard`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_label = () => `Account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_label = () => `Inloggen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_href = () => `https://www.klaviyo.com/support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_label = () => `Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_href = () => `https://www.klaviyo.com/search-all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_label = () => `Zoeken`


export { organisms_anchorLinks_backToTop } from "./en-US.js"

export { organisms_articleTableContents_overview } from "./en-US.js"

export { organisms_articleTableContents_tableContents } from "./en-US.js"

export { organisms_bfcmHero_eyebrow } from "./en-US.js"

export { organisms_bfcmHero_headline } from "./en-US.js"

export { organisms_bfcmHero_headlineFilter_iAm } from "./en-US.js"

export { organisms_bfcmHero_headlineFilter_iWantTo } from "./en-US.js"

export { organisms_bfcmHero_headlineFilter_thisBfcm } from "./en-US.js"

export { organisms_blogArticleHero_featureImageAltText } from "./en-US.js"

export { organisms_blogCards_viewAll } from "./en-US.js"

export { organisms_blogCards_viewCategory } from "./en-US.js"

export { organisms_blogLogoTag_tagline } from "./en-US.js"

export { organisms_blogLogoTag_title } from "./en-US.js"

export { organisms_blogSearchHero_customSearchHeadline } from "./en-US.js"

export { organisms_blogSearchHero_placeholder } from "./en-US.js"

export { organisms_countdownHero_days } from "./en-US.js"

export { organisms_countdownHero_hours } from "./en-US.js"

export { organisms_countdownHero_minutes } from "./en-US.js"

export { organisms_countdownHero_seconds } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_announcement } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productLaunch } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productPromotion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productUpdate } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_storewideSale } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_examplePrompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_loading } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_submit } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_excerpt = () => `Integreer je webshop en begin berichten te sturen met Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_href = () => `https://academy.klaviyo.com/en-us/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_postTitle = () => `Aan de slag met Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_resource = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_excerpt = () => `Leg de basis voor succesvol sms-berichten sturen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_href = () => `/hc/en-us/articles/4404274419355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_postTitle = () => `Sms configureren in Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_resource = () => `Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_excerpt = () => `Maak en stuur je eerste e-mailcampagne.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_href = () => `/hc/en-us/articles/115005054847`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_postTitle = () => `Een e-mailcampagne maken en sturen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_resource = () => `Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_excerpt = () => `Gebruik formulieren om met je abonnees te communiceren en meer informatie over ze te verzamelen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_href = () => `/hc/en-us/articles/360026474752`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_postTitle = () => `Aan de slag met aanmeldingsformulieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_resource = () => `Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_excerpt = () => `Maak grote aantallen volledige flows door te prompten in natuurlijke taal.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_href = () => `/hc/en-us/articles/26604555031963`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_postTitle = () => `Een flow maken met Flows AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_resource = () => `Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_excerpt = () => `Verzamel feedback van klanten en help meer conversies te genereren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_href = () => `/hc/en-us/articles/15937542819355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_postTitle = () => `Aan de slag met reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_resource = () => `Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuresList_loadMore = () => `Meer laden`


/**
 * @param {{ year: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_copyright = (params) => `Auteursrecht © ${params.year} Klaviyo. Alle rechten voorbehouden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_privacySettings = () => `Je privacy-instellingen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_articleMetaTitle = () => `Verzoek om toegang tot account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_href = () => `/hc/en-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_label = () => `Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_currentBreadcrumb = () => `Verzoek om toegang tot account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_email = () => `Zorg ervoor dat je e-mailadres maar één @ bevat, gevolgd door een geldig domein (naam@voorbeeld.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_issueRecipeients = () => `Voer een geldig e-mailadres in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_na_required = () => `Vereist: vul 'n.v.t.' in indien niet van toepassing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_required = () => `Verplicht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_websiteUrl = () => `Zorg ervoor dat de website van je bedrijf een geldig domein bevat (https://voorbeeld.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_label = () => `Account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_placeholder = () => `Vul je accountnaam in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_button_label = () => `+ Ontvanger toevoegen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_label = () => `Aanvullende ontvangers (optioneel)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_placeholder = () => `Vul een e-mailadres in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_label = () => `E-mailadres van je account bij Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_placeholder = () => `Vul een e-mailadres in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_label = () => `Waar heb je hulp bij nodig?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_placeholder = () => `Beschrijf het probleem`


export { organisms_forms_accountAccessForm_form_issueType_2_step_authentication } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_account_disabled = () => `Account is uitgeschakeld`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_forgot_password = () => `Wachtwoord vergeten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_invoice_inquiry = () => `Vraag over factuur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support = () => `Support voor verificatie in meerdere stappen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_account_owner = () => `Accounteigenaar updaten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_device_code = () => `Een nieuw apparaat instellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_setting_up_new_device = () => `Een nieuw apparaat instellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_label = () => `Probleem`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_placeholder = () => `Selecteer een probleem`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name = () => `Naam van de laatst gemaakte campagne of flow`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder = () => `Vul de naam van de campagne of flow in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url = () => `Maak een nieuwe pagina op de website van je bedrijf met de titel 'Klaviyo-test' en voer hier de URL daarvan in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder = () => `Voer de URL van de website in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info = () => `Beantwoord om veiligheidsredenen de volgende vragen zo goed mogelijk om je identiteit te laten verifiëren. Bij twijfel vul je 'n.v.t.' in.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_info = () => `Gebruik dit formulier alleen voor problemen met verificatie in meerdere stappen, zoals het verliezen van toegang tot je verificatieapparaat. Dit formulier vereist persoonlijke informatie voor handmatige verificatie. Selecteer een andere optie als je probleem geen betrekking heeft op verificatie in meerdere stappen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date = () => `Geschatte laatste inlogdatum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder = () => `Voer een datum in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address = () => `Geregistreerd postadres van organisatie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder = () => `Vul het adres in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails = () => `Namen of e-mailadressen van andere gebruikers van je account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder = () => `Vul namen of e-mailadressen in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names = () => `Namen of e-mailadressen van 5 profielen in je account die minstens 1 maand oud zijn`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder = () => `Voer namen of e-mailadressen in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason = () => `Selecteer een reden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_lost_access_authenticator_app = () => `Ik heb geen toegang meer tot de authenticator-app`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_device = () => `Nieuw apparaat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_phone_number = () => `Nieuw telefoonnummer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_sms_code = () => `Ik heb geen sms-code ontvangen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice = () => `Wat was het bedrag van je meest recente factuur van Klaviyo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder = () => `Voer het factuurbedrag in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_label = () => `Naam`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_placeholder = () => `Vul je volledige naam in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_submit_button_label = () => `Verzenden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_label = () => `Website-URL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_placeholder = () => `Vul een website-URL in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_headline = () => `Heb je problemen met toegang tot je account?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_subhead = () => `Stuur ons supportteam je gegevens. Je hoort snel van ons.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_href = () => `/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_label = () => `Naar Home`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_headline = () => `Je verzoek is ingediend`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_subhead = () => `Ons supportteam neemt zo snel mogelijk contact met je op. Je ontvangt een antwoord op één of meer opgegeven e-mailadressen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_allRequired = () => `Alle velden zijn vereist`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_body = () => `Krijg een gratis walkthrough en ontdek de kracht van het dataplatform, de AI-gestuurde inzichten, gepersonaliseerde sms en e-mail en andere functies van Klaviyo. `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_button = () => `Demo aanvragen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_buttonSubmitting = () => `Indienen…`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headline = () => `Vertel ons over je merk`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headlineEmbedded = () => `Vertel ons over je merk`


export { organisms_forms_demo_recaptcha_privacy } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonOne = () => `Alle functies bekijken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonTwo = () => `Marketingbronnen bekijken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_headline = () => `Je bent helemaal klaar!`


export { organisms_forms_errors_generic } from "./en-US.js"

export { organisms_forms_errors_network } from "./en-US.js"

export { organisms_forms_errors_rateLimit } from "./en-US.js"

export { organisms_forms_errors_recaptcha } from "./en-US.js"

export { organisms_forms_fields_agency_label } from "./en-US.js"

export { organisms_forms_fields_company_errors_required } from "./en-US.js"

export { organisms_forms_fields_company_label } from "./en-US.js"

export { organisms_forms_fields_company_placeholder } from "./en-US.js"

export { organisms_forms_fields_company_size_errors_required } from "./en-US.js"

export { organisms_forms_fields_company_size_label } from "./en-US.js"

export { organisms_forms_fields_company_size_options_fiveHundred } from "./en-US.js"

export { organisms_forms_fields_company_size_options_one } from "./en-US.js"

export { organisms_forms_fields_company_size_options_oneHundred } from "./en-US.js"

export { organisms_forms_fields_company_size_options_oneMillion } from "./en-US.js"

export { organisms_forms_fields_company_size_options_three } from "./en-US.js"

export { organisms_forms_fields_company_size_options_twentyFive } from "./en-US.js"

export { organisms_forms_fields_company_size_options_zero } from "./en-US.js"

export { organisms_forms_fields_company_size_placeholder } from "./en-US.js"

export { organisms_forms_fields_company_website_errors_required } from "./en-US.js"

export { organisms_forms_fields_company_website_errors_url } from "./en-US.js"

export { organisms_forms_fields_company_website_label } from "./en-US.js"

export { organisms_forms_fields_demo_requested_label } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_errors_required } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_label } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_BigCommerce } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Commercetools } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Magento } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Nuvemshop } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_OpenCart } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_PrestaShop } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Salesforce } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Shopify } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_ShopifyPlus } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Shopware } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_SquareOnline } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_Wix } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_WooCommerce } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_custom } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_doesNotApply } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_options_other } from "./en-US.js"

export { organisms_forms_fields_ecomm_platform_placeholder } from "./en-US.js"

export { organisms_forms_fields_email_errors_email } from "./en-US.js"

export { organisms_forms_fields_email_errors_required } from "./en-US.js"

export { organisms_forms_fields_email_label } from "./en-US.js"

export { organisms_forms_fields_email_placeholder } from "./en-US.js"

export { organisms_forms_fields_field_15_errors_required } from "./en-US.js"

export { organisms_forms_fields_field_15_label } from "./en-US.js"

export { organisms_forms_fields_field_15_options_five } from "./en-US.js"

export { organisms_forms_fields_field_15_options_fourHundred } from "./en-US.js"

export { organisms_forms_fields_field_15_options_twenty } from "./en-US.js"

export { organisms_forms_fields_field_15_options_underFive } from "./en-US.js"

export { organisms_forms_fields_field_15_placeholder } from "./en-US.js"

export { organisms_forms_fields_field_16_errors_required } from "./en-US.js"

export { organisms_forms_fields_field_16_label } from "./en-US.js"

export { organisms_forms_fields_field_16_options_clientsBusiness } from "./en-US.js"

export { organisms_forms_fields_field_16_options_ownBusiness } from "./en-US.js"

export { organisms_forms_fields_field_16_placeholder } from "./en-US.js"

export { organisms_forms_fields_field_17_errors_required } from "./en-US.js"

export { organisms_forms_fields_field_17_label } from "./en-US.js"

export { organisms_forms_fields_field_17_options_other } from "./en-US.js"

export { organisms_forms_fields_field_17_options_retailGoods } from "./en-US.js"

export { organisms_forms_fields_field_17_options_retailServices } from "./en-US.js"

export { organisms_forms_fields_field_17_placeholder } from "./en-US.js"

export { organisms_forms_fields_firstname_errors_required } from "./en-US.js"

export { organisms_forms_fields_full_name_errors_required } from "./en-US.js"

export { organisms_forms_fields_full_name_label } from "./en-US.js"

export { organisms_forms_fields_full_name_placeholder } from "./en-US.js"

export { organisms_forms_fields_general_errors_required } from "./en-US.js"

export { organisms_forms_fields_lastname_errors_required } from "./en-US.js"

export { organisms_forms_fields_newsletter_label } from "./en-US.js"

export { organisms_forms_fields_password_errors_common } from "./en-US.js"

export { organisms_forms_fields_password_errors_max } from "./en-US.js"

export { organisms_forms_fields_password_errors_min } from "./en-US.js"

export { organisms_forms_fields_password_errors_required } from "./en-US.js"

export { organisms_forms_fields_password_label } from "./en-US.js"

export { organisms_forms_fields_password_placeholder } from "./en-US.js"

export { organisms_forms_fields_phone_errors_matches } from "./en-US.js"

export { organisms_forms_fields_phone_errors_max } from "./en-US.js"

export { organisms_forms_fields_phone_errors_required } from "./en-US.js"

export { organisms_forms_fields_phone_label } from "./en-US.js"

export { organisms_forms_fields_phone_placeholder } from "./en-US.js"

export { organisms_forms_fields_product_interest_errors_required } from "./en-US.js"

export { organisms_forms_fields_product_interest_label } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_cdp } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_email } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_mobile_push } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_reviews } from "./en-US.js"

export { organisms_forms_fields_product_interest_options_sms } from "./en-US.js"

export { organisms_forms_fields_product_interest_placeholder } from "./en-US.js"

export { organisms_forms_fields_website_errors_url } from "./en-US.js"

export { organisms_forms_legal_acknowledgement } from "./en-US.js"

export { organisms_forms_legal_and } from "./en-US.js"

export { organisms_forms_legal_privacyPolicy_href } from "./en-US.js"

export { organisms_forms_legal_privacyPolicy_label } from "./en-US.js"

export { organisms_forms_legal_termsOfService } from "./en-US.js"

export { organisms_forms_legal_termsOfService_href } from "./en-US.js"

export { organisms_forms_signup_body } from "./en-US.js"

export { organisms_forms_signup_button } from "./en-US.js"

export { organisms_forms_signup_buttonSubmitting } from "./en-US.js"

export { organisms_forms_signup_headline } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_glossary_jumpTo = () => `Ga naar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_allLocations = () => `Alle locaties`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_search = () => `Zoeken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_searchJobs = () => `Vacatures zoeken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_allSystemsOperational = () => `Alle systemen zijn operationeel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_degradedSystemService = () => `Beperkte systeemservice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_majorSystemOutage = () => `Grote systeemstoring`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorServiceOutage = () => `Kleine servicestoring`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorSystemOutage = () => `Kleine systeemstoring`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partialSystemOutage = () => `Gedeeltelijke systeemstoring`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedService = () => `Gedeeltelijk beperkte service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem = () => `Gedeeltelijk beperkte systeemprestaties`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance = () => `Service in onderhoud`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_modal_closeModal = () => `Venster sluiten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_href = () => `https://community.klaviyo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_label = () => `Naar de community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_eyebrow = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_icon_iconName = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_richText = () => `Maak contact met collega's, partners en Klaviyo-experts om inspiratie op te doen, inzichten te delen en antwoorden te krijgen op al je vragen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_href = () => `https://www.klaviyo.com/events/live-training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_label = () => `Nu aanmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_eyebrow = () => `Live training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_icon_iconName = () => `Kalender`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_richText = () => `Neem deel aan een live sessie met Klaviyo-experts voor meer informatie over best practices, het instellen van belangrijke functies en andere onderwerpen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_label = () => `Inloggen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_eyebrow = () => `Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_icon_iconName = () => `Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_accessSupport = () => `Krijg ondersteuning via je account.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistance = () => `Chat-/virtuele assistentie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability = () => `Beschikbaarheid varieert per locatie en type abonnement`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupport = () => `E-mailsupport`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAccountTypes = () => `(gratis proefperiodes en betaalde accounts)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAvailability = () => `24/7 beschikbaar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewAllButton_text = () => `Alle categorieën bekijken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewLessButton_text = () => `Minder categorieën bekijken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_href = () => `/demo-request`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_label = () => `Demo aanvragen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_signUp_button_href = () => `/sign-up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_logo_label = () => `Naar de startpagina van Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_href = () => `https://www.klaviyo.com/customer-resources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_label = () => `Naar de pagina met hulpbronnen van de Klaviyo power-up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_klavioLogo = () => `Logo van Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_productNews = () => `Productnieuws van Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_read = () => `Lezen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_viewAll = () => `Alles bekijken`


export { organisms_post_filter_ResourceCategory } from "./en-US.js"

export { organisms_post_filter_ResourceCollection } from "./en-US.js"

export { organisms_post_filter_ResourceStage } from "./en-US.js"

export { organisms_post_filter_ResourceTopic } from "./en-US.js"

export { organisms_post_filter_read_more } from "./en-US.js"

export { organisms_post_filter_search } from "./en-US.js"

export { organisms_pricing_calculator_carrierFeeDisclaimer } from "./en-US.js"

export { organisms_pricing_calculator_carrierFeeDisclaimerEnd } from "./en-US.js"

export { organisms_pricing_calculator_credit } from "./en-US.js"

export { organisms_pricing_calculator_credits } from "./en-US.js"

export { organisms_pricing_calculator_destination } from "./en-US.js"

export { organisms_pricing_calculator_headline } from "./en-US.js"

export { organisms_pricing_calculator_locales_AT } from "./en-US.js"

export { organisms_pricing_calculator_locales_AU } from "./en-US.js"

export { organisms_pricing_calculator_locales_BE } from "./en-US.js"

export { organisms_pricing_calculator_locales_CA } from "./en-US.js"

export { organisms_pricing_calculator_locales_CH } from "./en-US.js"

export { organisms_pricing_calculator_locales_DE } from "./en-US.js"

export { organisms_pricing_calculator_locales_DK } from "./en-US.js"

export { organisms_pricing_calculator_locales_ES } from "./en-US.js"

export { organisms_pricing_calculator_locales_FI } from "./en-US.js"

export { organisms_pricing_calculator_locales_FR } from "./en-US.js"

export { organisms_pricing_calculator_locales_GB } from "./en-US.js"

export { organisms_pricing_calculator_locales_HU } from "./en-US.js"

export { organisms_pricing_calculator_locales_IE } from "./en-US.js"

export { organisms_pricing_calculator_locales_IT } from "./en-US.js"

export { organisms_pricing_calculator_locales_NL } from "./en-US.js"

export { organisms_pricing_calculator_locales_NO } from "./en-US.js"

export { organisms_pricing_calculator_locales_NZ } from "./en-US.js"

export { organisms_pricing_calculator_locales_PL } from "./en-US.js"

export { organisms_pricing_calculator_locales_PT } from "./en-US.js"

export { organisms_pricing_calculator_locales_SE } from "./en-US.js"

export { organisms_pricing_calculator_locales_US } from "./en-US.js"

export { organisms_pricing_calculator_maxSends } from "./en-US.js"

export { organisms_pricing_calculator_mms } from "./en-US.js"

export { organisms_pricing_calculator_mms_limit } from "./en-US.js"

export { organisms_pricing_calculator_mms_not_available } from "./en-US.js"

export { organisms_pricing_calculator_not_available } from "./en-US.js"

export { organisms_pricing_calculator_pricePer } from "./en-US.js"

export { organisms_pricing_calculator_pricePerSend } from "./en-US.js"

export { organisms_pricing_calculator_sendTo } from "./en-US.js"

export { organisms_pricing_calculator_service_type } from "./en-US.js"

export { organisms_pricing_calculator_sms } from "./en-US.js"

export { organisms_pricing_calculator_sms_limit } from "./en-US.js"

export { organisms_pricing_contactLimitExceeded } from "./en-US.js"

export { organisms_pricing_contactSales } from "./en-US.js"

export { organisms_pricing_contacts } from "./en-US.js"

export { organisms_pricing_contacts_slider_headline } from "./en-US.js"

export { organisms_pricing_contacts_slider_subText } from "./en-US.js"

export { organisms_pricing_contacts_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_credits_slider_headline } from "./en-US.js"

export { organisms_pricing_credits_slider_subText } from "./en-US.js"

export { organisms_pricing_credits_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_csm } from "./en-US.js"

export { organisms_pricing_emailAndChatSupport } from "./en-US.js"

export { organisms_pricing_eyebrow } from "./en-US.js"

export { organisms_pricing_freeCredits } from "./en-US.js"

export { organisms_pricing_freeSupport } from "./en-US.js"

export { organisms_pricing_getADemo } from "./en-US.js"

export { organisms_pricing_headline } from "./en-US.js"

export { organisms_pricing_includesFees } from "./en-US.js"

export { organisms_pricing_maxContacts_buttons_getDemo } from "./en-US.js"

export { organisms_pricing_maxContacts_headline } from "./en-US.js"

export { organisms_pricing_maxContacts_richTextBody } from "./en-US.js"

export { organisms_pricing_mobilePush } from "./en-US.js"

export { organisms_pricing_modalContent_copyText1 } from "./en-US.js"

export { organisms_pricing_modalContent_copyText2 } from "./en-US.js"

export { organisms_pricing_modalContent_headline } from "./en-US.js"

export { organisms_pricing_month } from "./en-US.js"

export { organisms_pricing_monthlyEmailSends } from "./en-US.js"

export { organisms_pricing_monthlySmsMmsCredits } from "./en-US.js"

export { organisms_pricing_onboarding } from "./en-US.js"

export { organisms_pricing_opensAModal } from "./en-US.js"

export { organisms_pricing_per_month } from "./en-US.js"

export { organisms_pricing_plans_advance_data_platform_subTextTooltiptInfo } from "./en-US.js"

export { organisms_pricing_plans_advanced_data_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_advanced_data_platform_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_collapsible_button } from "./en-US.js"

export { organisms_pricing_plans_emailAndSms_calloutText } from "./en-US.js"

export { organisms_pricing_plans_emailAndSms_copy } from "./en-US.js"

export { organisms_pricing_plans_emailAndSms_name } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_creditsSubText } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_name } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_recommended } from "./en-US.js"

export { organisms_pricing_plans_email_calloutText } from "./en-US.js"

export { organisms_pricing_plans_email_copy } from "./en-US.js"

export { organisms_pricing_plans_email_emails_label } from "./en-US.js"

export { organisms_pricing_plans_email_name } from "./en-US.js"

export { organisms_pricing_plans_email_per_month } from "./en-US.js"

export { organisms_pricing_plans_expandable_button } from "./en-US.js"

export { organisms_pricing_plans_free_calloutText } from "./en-US.js"

export { organisms_pricing_plans_free_copy } from "./en-US.js"

export { organisms_pricing_plans_free_name } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_bottom } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_top } from "./en-US.js"

export { organisms_pricing_plans_getStarted_text } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_headline } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_price_subText } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_subText } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_above250kContacts } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_below250Contacts } from "./en-US.js"

export { organisms_pricing_plans_platform_advanced_data_platform_subText } from "./en-US.js"

export { organisms_pricing_plans_platform_advanced_data_platform_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_reviews_headline } from "./en-US.js"

export { organisms_pricing_plans_reviews_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_reviews_slider_subText } from "./en-US.js"

export { organisms_pricing_plans_reviews_subText } from "./en-US.js"

export { organisms_pricing_plusSign } from "./en-US.js"

export { organisms_pricing_rates_regionAUS_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionAUS_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionAUS_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionCanada_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionCanada_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionCanada_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionFrance_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionFrance_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionFrance_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionGermany_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionGermany_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionGermany_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionIreland_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionIreland_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionIreland_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionItaly_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionItaly_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionItaly_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionNZ_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionNZ_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionNZ_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionNetherlands_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionNetherlands_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionNetherlands_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionPortugal_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionPortugal_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionPortugal_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionUK_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionUK_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionUK_regionName } from "./en-US.js"

export { organisms_pricing_rates_regionUSA_creditEntryMms } from "./en-US.js"

export { organisms_pricing_rates_regionUSA_creditEntrySms } from "./en-US.js"

export { organisms_pricing_rates_regionUSA_regionName } from "./en-US.js"

export { organisms_pricing_signUp } from "./en-US.js"

export { organisms_pricing_startingAt } from "./en-US.js"

export { organisms_pricing_supportToScale } from "./en-US.js"

export { organisms_scroll_social_proof_button } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_3 } from "./en-US.js"

export { organisms_scroll_social_proof_href } from "./en-US.js"

export { organisms_scroll_social_proof_quote_end } from "./en-US.js"

export { organisms_scroll_social_proof_quote_start } from "./en-US.js"

export { organisms_searchBar_placeholder_case_study } from "./en-US.js"

export { organisms_searchBar_placeholder_compare_page } from "./en-US.js"

export { organisms_searchBar_placeholder_marketing_resource } from "./en-US.js"

export { organisms_searchBar_placeholder_newsroom_article } from "./en-US.js"

export { organisms_searchBar_placeholder_page } from "./en-US.js"

export { organisms_searchBar_placeholder_partner_page } from "./en-US.js"

export { organisms_searchBar_placeholder_podcast_page } from "./en-US.js"

export { organisms_searchBar_placeholder_post } from "./en-US.js"

export { organisms_searchBar_placeholder_product_update } from "./en-US.js"

export { organisms_searchBar_placeholder_solutions_page } from "./en-US.js"

export { organisms_searchBar_placeholder_success_page } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_button } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_href } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_subhead } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_benchmarks } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_customer_hub } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_email_marketing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_integrations } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_klaviyo_ai } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_mobile_push } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_profiles } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_reporting } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_reviews } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_segments } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_sms_marketing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_e } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_f } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_g } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_e } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_f } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_g } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_3_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_3_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_27Percent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_43Percent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_clickRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_consentedToReceiveSMS } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_createWithAI } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_describeFlow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_dontLeaveItBehind } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_generateDraft } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_hasViewedProduct } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_klaviyoAI } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_smsABTest } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_viewAbandonedProduct } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_weLoveThatYouLoveThisDontLeaveItBehindClickToShop } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_whenSomeoneViewsAProductAndDoesNotBuySendAnSMS } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_attributedRevenue } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_attributedRevenueNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_champions } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_championsFlow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_clickRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_conversionOverview } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_conversionRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_eightPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_excellent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_exclusiveOffer } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fivePointTwoZeroPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fortyThreeThousandSixHundredNineteen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fourHundredFiftyTwo } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_membersAdded } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_membersDropped } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_monthOne } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_monthTwo } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_oneThousandFiveHundredThirteen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_revenue } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_revenueNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_rfmGroupIsChampion } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_segmentGrowthReport } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_sevenPointFiveZeroPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_threePercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_totalMembers } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_accessories } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_activity } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_addToBag } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_addToCart } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_arrivingToday } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_chat } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_clothing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_color } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_coral } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_featherweightRunningShoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_findAStore } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_forYou } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_help } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_horizonRibbedTrainingSet } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_l } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_maroon } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_membersFreeShippingOnOrdersFiftyPlus } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_miaWilliams } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_miaWilliamsAtAbcDotCom } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedTheWrongSizeShoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_new } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_orders } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_phoneNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_pleaseHoldForAMomentWhileWeConnectYouWithAnAgent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_profile } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_recentlyViewed } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_saySomething } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_seanH } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_selectSize } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_shoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_sky } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_sorryAboutThatMiaWellGetTheCorrectColorShippedOutToday } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_thirtyFivePointNinetyNine } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_twoHundredTen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_unifiedInbox } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_welcomeMia } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xl } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xs } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xxl } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_yesThatsMyOrderThanksForYourHelp } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_Enjoy } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_customerActivity } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_discountCode } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_email } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_inbox } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_leftFiveStarReview } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_name } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_openedEmailDiscount } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_orderDelivered } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_orderShipped } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_placedOrderForTwoHundredSix } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_shopNow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_tenPercentOff } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_thanksForYourFeedbackEnjoy } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_4 } from "./en-US.js"

export { organisms_tileList_viewAll } from "./en-US.js"

export { organisms_video_playVideo } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_clearAll = () => `Alles wissen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_collapseAll = () => `Alles samenvouwen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_filterTitle = () => `Alle updates`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_placeholder = () => `Zoeken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_accounts_billing = () => `Account en facturering`


export { organisms_whatsNew_refinements_advanced_kdp } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_analytics = () => `Analyses`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_audience = () => `Publiek`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_benefits = () => `Voordelen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_campaigns = () => `Campagnes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_coming_soon = () => `Binnenkort beschikbaar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_deliver_compliance = () => `Bezorgbaarheid en compliance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_email = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_flows = () => `Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_general_availability = () => `Algemeen beschikbaar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_gradual_release = () => `Geleidelijke release`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_integrations = () => `Integraties`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_limited_availability = () => `Beperkt beschikbaar`


export { organisms_whatsNew_refinements_marketing_analytics } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_push_notifications = () => `Pushmeldingen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_release_type = () => `Type release`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_reviews = () => `Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sign_up_forms = () => `Aanmeldingsformulieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sms = () => `Sms`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_topic = () => `Onderwerp`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_watchQuarterlyRecap = () => `Bekijk de samenvatting van het kwartaal`


export { pages_careers_searchJobs_breadcrumbs_home } from "./en-US.js"

export { pages_careers_searchJobs_breadcrumbs_searchJobs } from "./en-US.js"

export { pages_careers_searchJobs_form_applyFilters } from "./en-US.js"

export { pages_careers_searchJobs_form_clearFilters } from "./en-US.js"

export { pages_careers_searchJobs_form_country } from "./en-US.js"

export { pages_careers_searchJobs_form_keywords } from "./en-US.js"

export { pages_careers_searchJobs_form_keywordsPlaceholder } from "./en-US.js"

export { pages_careers_searchJobs_form_legend } from "./en-US.js"

export { pages_careers_searchJobs_form_location } from "./en-US.js"

export { pages_careers_searchJobs_form_noResults } from "./en-US.js"

export { pages_careers_searchJobs_form_noResultsReset } from "./en-US.js"

export { pages_careers_searchJobs_form_searchResults } from "./en-US.js"

export { pages_careers_searchJobs_form_team } from "./en-US.js"

export { pages_careers_searchJobs_headline } from "./en-US.js"

export { pages_careers_searchJobs_pageTitle } from "./en-US.js"

export { pages_careers_searchJobs_recentJobs } from "./en-US.js"

export { pages_careers_searchJobs_savedJobs } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_bodyCopy = () => `Niet wat je zocht? Ga naar de <a href="/email-marketing">e-mailpagina</a>, de <a href="/sms-marketing">sms-pagina</a> of ga naar <a href="/">Home</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_button = () => `Naar Home`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_eyebrow = () => `Pagina niet gevonden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_itsPronounced = () => `Zo wordt het uitgesproken:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardHours = () => `uur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardMinutes = () => `minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularHour = () => `uur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularMinute = () => `minuut`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_community_answered = () => `Vraag beantwoord`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_academy = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_allResources = () => `Alle hulpbronnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_clearAll = () => `Alles wissen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_collapseAll = () => `Alles samenvouwen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_community = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_developers = () => `Ontwikkelaars`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_helpCenter = () => `Helpcentrum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_klaviyoHome = () => `Marketinghulpbronnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_resource = () => `Hulpbron`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_headline = () => `In alle bronnen zoeken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsSubTitle = () => `Check de spelling of probeer een andere zoekopdracht.`


/**
 * @param {{ query: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsTitle = (params) => `Geen resultaten gevonden voor '${params.query}'.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_placeholder = () => `Zoeken op onderwerp of zoekwoord`


export { pages_search_refinementsAccordionLabel_academy_duration } from "./en-US.js"

export { pages_search_refinementsAccordionLabel_academy_language } from "./en-US.js"

export { pages_search_refinementsAccordionLabel_academy_location } from "./en-US.js"

export { pages_search_refinementsAccordionLabel_academy_type } from "./en-US.js"

export { pages_search_refinements_academy_language_english } from "./en-US.js"

export { pages_search_refinements_academy_language_french } from "./en-US.js"

export { pages_search_refinements_academy_language_spanish } from "./en-US.js"

export { pages_search_refinements_academy_location_apac } from "./en-US.js"

export { pages_search_refinements_academy_location_emea } from "./en-US.js"

export { pages_search_refinements_academy_location_nam } from "./en-US.js"

export { pages_search_refinements_academy_type_liveTraining } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_category = () => `Categorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType = () => `Type artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_bfcm_page = () => `Black Friday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_case_study = () => `Casestudy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_compare_page = () => `Vergelijkingen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_demos_page = () => `Demo's`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_industry_page = () => `Branches`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_marketing_resource = () => `Marketinghulpbron`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_newsroom_article = () => `Bedrijfsnieuws`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_page = () => `Pagina's`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_partner_page = () => `Partners`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_podcast_page = () => `Podcast`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_post = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_product_update = () => `Productupdate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_products_page = () => `Producten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_quarterly_page = () => `Driemaandelijkse release`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_solutions_page = () => `Oplossingen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_success_page = () => `Klaar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_tools_page = () => `Tools`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_accounts_billing = () => `Account en facturering`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_analytics = () => `Analyses`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_audience = () => `Publiek`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_campaigns = () => `Campagnes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_cdp = () => `Platform voor klantgegevens`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_deliver_compliance = () => `Bezorgbaarheid en compliance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_email = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_flows = () => `Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_integrations = () => `Integraties`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_push_notifications = () => `Pushmeldingen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_reviews = () => `Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sign_up_forms = () => `Aanmeldingsformulieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sms = () => `Sms`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelTop = () => `Belangrijkste zoekresultaten`


/**
 * @param {{ y: NonNullable<unknown>, x: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelYofX = (params) => `Toont ${params.y} van ${params.x}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearchesTitle = () => `Aanbevolen zoekopdrachten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search1 = () => `Aan de slag met Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search2 = () => `Aan de slag met sms`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search3 = () => `Aan de slag met het platform voor klantgegevens van Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search4 = () => `Aan de slag met formulieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search5 = () => `Black Friday Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search6 = () => `Maak een contentplanning in Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_toggleLabel = () => `Weergave`


/**
 * @param {{ index: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewAllResults = (params) => `Alle ${params.index}-resultaten bekijken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewMoreResults = () => `Meer bekijken`


export { pages_sitemap_header } from "./en-US.js"

export { pages_sitemap_title } from "./en-US.js"

export { roiCalculator_form_brandText } from "./en-US.js"

export { roiCalculator_form_channelsUsed } from "./en-US.js"

export { roiCalculator_form_fieldsRequired } from "./en-US.js"

export { roiCalculator_form_inputActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputEnterAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputEnterCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputEnterOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputPrefix } from "./en-US.js"

export { roiCalculator_form_inputSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_roiButton } from "./en-US.js"

export { roiCalculator_form_toggleEmail } from "./en-US.js"

export { roiCalculator_form_toggleEmailAndSms } from "./en-US.js"

export { roiCalculator_results_automatedFlows } from "./en-US.js"

export { roiCalculator_results_campaigns } from "./en-US.js"

export { roiCalculator_results_freeTier } from "./en-US.js"

export { roiCalculator_results_getStartedButton } from "./en-US.js"

export { roiCalculator_results_headlineText } from "./en-US.js"

export { roiCalculator_results_invalidRoi } from "./en-US.js"

export { roiCalculator_results_newSubscribers } from "./en-US.js"

export { roiCalculator_results_revenuePerYear } from "./en-US.js"

export { roiCalculator_results_signupText } from "./en-US.js"

export { roiCalculator_results_subHeadlineText } from "./en-US.js"

export { roiCalculator_results_talkToSales } from "./en-US.js"

export { templates_archive_author_openInANewTab } from "./en-US.js"

export { templates_archive_author_postsByThisAuthor } from "./en-US.js"

export { templates_archive_category_articles } from "./en-US.js"

export { templates_archive_category_featured } from "./en-US.js"

export { templates_caseStudy_customer } from "./en-US.js"

export { templates_caseStudy_industry } from "./en-US.js"

export { templates_caseStudy_platform } from "./en-US.js"

export { pages_b2ccrm_hero_video_id } from "./en-US.js"

export { pages_b2ccrm_introduction_subtext } from "./en-US.js"

export { pages_b2ccrm_marketing_p1 } from "./en-US.js"

export { pages_b2ccrm_marketing_p2 } from "./en-US.js"

export { pages_b2ccrm_marketing_p3 } from "./en-US.js"

export { pages_b2ccrm_service_p1 } from "./en-US.js"

export { pages_b2ccrm_service_rive_message_2 } from "./en-US.js"

export { pages_b2ccrm_service_rive_phone_number } from "./en-US.js"

export { pages_b2ccrm_analytics_rive_revenue_number_sign } from "./en-US.js"

export { pages_b2ccrm_platform_rive_placed_order } from "./en-US.js"

export { pages_b2ccrm_service_rive_dash_item_cost } from "./en-US.js"

export { pages_b2ccrm_service_rive_item_price } from "./en-US.js"

export { pages_b2ccrm_service_rive_shipping } from "./en-US.js"

export { roiCalculator_results_getStartedButton_href } from "./en-US.js"

export { roiCalculator_results_talkToSales_href } from "./en-US.js"

export { AppMarketplace_Browse_Filters_Apply } from "./en-US.js"

export { AppMarketplace_Browse_Filters_BuiltBy } from "./en-US.js"

export { AppMarketplace_Browse_Filters_Category } from "./en-US.js"

export { AppMarketplace_Browse_Filters_CollapseAll } from "./en-US.js"

export { AppMarketplace_Browse_Filters_FilterItemWithCount } from "./en-US.js"

export { AppMarketplace_Browse_Filters_MobileFilterLabel } from "./en-US.js"

export { AppMarketplace_Browse_Filters_MobileFilterLabelWithCount } from "./en-US.js"

export { AppMarketplace_Browse_Filters_ResetAll } from "./en-US.js"

export { AppMarketplace_Browse_Heading } from "./en-US.js"

export { AppMarketplace_Browse_Heading_SearchTermMatchCount_Plural } from "./en-US.js"

export { AppMarketplace_Browse_Heading_SearchTermMatchCount_Singular } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Body } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Body_Alt } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Heading } from "./en-US.js"

export { AppMarketplace_Details_Articles_CaseStudyImage_Alt } from "./en-US.js"

export { AppMarketplace_Details_Articles_NavigationIcon_Alt } from "./en-US.js"

export { AppMarketplace_Details_Articles_UserGuideIcon_Alt } from "./en-US.js"

export { AppMarketplace_Details_Info_ApplicationLogo_Alt } from "./en-US.js"

export { AppMarketplace_Details_InstallButton_UninstallableWarningImage_Alt } from "./en-US.js"

export { AppMarketplace_Details_Page_Title } from "./en-US.js"

export { AppMarketplace_Discovery_App_BuiltBy } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_ActionRequired } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_GenericPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_Installed } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_UserPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Card_BannerImage_Alt } from "./en-US.js"

export { AppMarketplace_Discovery_Card_Icon_Alt } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllApps } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllAppsAriaLabel } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL1 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2Highlight } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericMobileHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_LogInAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_SignUpAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserGreeting } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserHeading } from "./en-US.js"

export { AppMarketplace_Drawer_AccountManagement } from "./en-US.js"

export { AppMarketplace_Drawer_ApplicationManagement } from "./en-US.js"

export { AppMarketplace_Drawer_Categories } from "./en-US.js"

export { AppMarketplace_Header_CategoriesButton_Label } from "./en-US.js"

export { AppMarketplace_Header_LoginButton_Label } from "./en-US.js"

export { AppMarketplace_Header_Logo_Alt } from "./en-US.js"

export { AppMarketplace_Header_MenuIcon_Alt } from "./en-US.js"

export { AppMarketplace_Header_SearchBar_Placeholder } from "./en-US.js"

export { AppMarketplace_Header_SearchBar_SearchIcon_Alt } from "./en-US.js"

export { AppMarketplace_Header_SearchResults_ApplicationsSection_Label } from "./en-US.js"

export { AppMarketplace_Header_SearchResults_CategoriesSection_Label } from "./en-US.js"

export { AppMarketplace_Preview_Site_Title } from "./en-US.js"

export { AppMarketplace_Site_Description } from "./en-US.js"

export { AppMarketplace_Site_Title } from "./en-US.js"

export { academy_lesson_bottom_nav_catalog_label } from "./en-US.js"

export { academy_lesson_bottom_nav_collection_label } from "./en-US.js"

export { academy_pages_bestPractices_headline } from "./en-US.js"

export { academy_pages_bestPractices_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_headline } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_subhead } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_title } from "./en-US.js"

export { academy_pages_cred_faq_headline } from "./en-US.js"

export { academy_pages_cred_faq_row0_content } from "./en-US.js"

export { academy_pages_cred_faq_row0_title } from "./en-US.js"

export { academy_pages_cred_faq_row1_content } from "./en-US.js"

export { academy_pages_cred_faq_row1_title } from "./en-US.js"

export { academy_pages_cred_faq_row2_content } from "./en-US.js"

export { academy_pages_cred_faq_row2_title } from "./en-US.js"

export { academy_pages_cred_faq_row3_content } from "./en-US.js"

export { academy_pages_cred_faq_row3_title } from "./en-US.js"

export { academy_pages_cred_faq_row4_content } from "./en-US.js"

export { academy_pages_cred_faq_row4_title } from "./en-US.js"

export { academy_pages_cred_faq_row5_content } from "./en-US.js"

export { academy_pages_cred_faq_row5_title } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_4 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_5 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_6 } from "./en-US.js"

export { academy_pages_cred_faq_row6_title } from "./en-US.js"

export { academy_pages_cred_faq_subhead } from "./en-US.js"

export { academy_pages_cred_landing_34 } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_collapse } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_expand } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_subtitle } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_header } from "./en-US.js"

export { academy_pages_cred_landing_hero_headline } from "./en-US.js"

export { academy_pages_cred_landing_hero_subhead } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_headline } from "./en-US.js"

export { academy_partner_tag } from "./en-US.js"

export { academy_search_href } from "./en-US.js"

export { app_marketplace_details_built_by } from "./en-US.js"

export { app_marketplace_details_carousel_close } from "./en-US.js"

export { app_marketplace_details_carousel_image_alt } from "./en-US.js"

export { app_marketplace_details_carousel_next_image } from "./en-US.js"

export { app_marketplace_details_carousel_previous_image } from "./en-US.js"

export { app_marketplace_details_case_study } from "./en-US.js"

export { app_marketplace_details_category } from "./en-US.js"

export { app_marketplace_details_cover_image } from "./en-US.js"

export { app_marketplace_details_developer } from "./en-US.js"

export { app_marketplace_details_features } from "./en-US.js"

export { app_marketplace_details_guide } from "./en-US.js"

export { app_marketplace_details_install } from "./en-US.js"

export { app_marketplace_details_install_installs } from "./en-US.js"

export { app_marketplace_details_languages } from "./en-US.js"

export { app_marketplace_details_marketing_video } from "./en-US.js"

export { app_marketplace_details_overview } from "./en-US.js"

export { app_marketplace_details_pricing } from "./en-US.js"

export { app_marketplace_details_pricing_free } from "./en-US.js"

export { app_marketplace_details_pricing_learn_more } from "./en-US.js"

export { app_marketplace_details_similar_apps } from "./en-US.js"

export { app_marketplace_details_support } from "./en-US.js"

export { app_marketplace_details_support_email_address_label } from "./en-US.js"

export { app_marketplace_details_support_help } from "./en-US.js"

export { app_marketplace_details_support_privacy } from "./en-US.js"

export { app_marketplace_details_support_website } from "./en-US.js"

export { app_marketplace_details_user_guide } from "./en-US.js"

export { app_marketplace_gallery_thumbnail } from "./en-US.js"

export { app_marketplace_gallery_thumbnail_alt } from "./en-US.js"

export { app_marketplace_install_alert_learn_more } from "./en-US.js"

export { app_marketplace_install_button } from "./en-US.js"

export { app_marketplace_install_status_invalid_permissions } from "./en-US.js"

export { app_marketplace_install_status_unhealthy } from "./en-US.js"

export { app_marketplace_install_status_uninstallable } from "./en-US.js"

export { app_marketplace_installed_button } from "./en-US.js"

export { app_marketplace_manage_button } from "./en-US.js"

export { app_marketplace_notFound_button_text } from "./en-US.js"

export { app_marketplace_notFound_page_title } from "./en-US.js"

export { app_marketplace_preview_banner } from "./en-US.js"

export { developer_portal_get_started_card_one_description } from "./en-US.js"

export { developer_portal_get_started_card_one_title } from "./en-US.js"

export { developer_portal_get_started_card_three_description } from "./en-US.js"

export { developer_portal_get_started_card_three_title } from "./en-US.js"

export { developer_portal_get_started_card_two_description } from "./en-US.js"

export { developer_portal_get_started_card_two_title } from "./en-US.js"

export { developer_portal_get_started_header } from "./en-US.js"

export { developer_portal_need_more_help_card_one_description } from "./en-US.js"

export { developer_portal_need_more_help_card_one_title } from "./en-US.js"

export { developer_portal_need_more_help_card_two_description } from "./en-US.js"

export { developer_portal_need_more_help_card_two_title } from "./en-US.js"

export { developer_portal_need_more_help_header } from "./en-US.js"

export { developer_portal_use_cases_cta } from "./en-US.js"

export { developer_portal_use_cases_header } from "./en-US.js"

export { developer_portal_use_cases_tab_one_author } from "./en-US.js"

export { developer_portal_use_cases_tab_one_description } from "./en-US.js"

export { developer_portal_use_cases_tab_one_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_one_title } from "./en-US.js"

export { developer_portal_use_cases_tab_three_author } from "./en-US.js"

export { developer_portal_use_cases_tab_three_description } from "./en-US.js"

export { developer_portal_use_cases_tab_three_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_three_title } from "./en-US.js"

export { developer_portal_use_cases_tab_two_author } from "./en-US.js"

export { developer_portal_use_cases_tab_two_description } from "./en-US.js"

export { developer_portal_use_cases_tab_two_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_two_title } from "./en-US.js"

export { molecules_blogCard_related_content } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_href = () => `/en-us/profile`


export { organisms_forms_fields_company_website_placeholder } from "./en-US.js"

export { organisms_forms_fields_firstname_placeholder } from "./en-US.js"

export { organisms_forms_fields_form_opt_in_label } from "./en-US.js"

export { organisms_forms_fields_lastname_placeholder } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_errors_required } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_placeholder } from "./en-US.js"

export { organisms_forms_fields_website_errors_required } from "./en-US.js"

export { organisms_forms_fields_website_placeholder } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_openInNewTab = () => `onwaar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_openInNewTab = () => `onwaar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_openInNewTab = () => `onwaar`


/**
 * @param {{ accessSupport: NonNullable<unknown>, emailSupport: NonNullable<unknown>, emailSupportAccountTypes: NonNullable<unknown>, emailSupportAvailability: NonNullable<unknown>, chatVirtualAssistance: NonNullable<unknown>, chatVirtualAssistanceAvailability: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_template = (params) => `<p>${params.accessSupport}</p>
    <p class="supportMethod">
      <strong class="methodName">${params.emailSupport}</strong> <span class="methodDetail"><em>${params.emailSupportAccountTypes}</em></span>
      ${params.emailSupportAvailability}
    </p>
    <p class="supportMethod">
      <strong class="methodName">${params.chatVirtualAssistance}<br/></strong>
      ${params.chatVirtualAssistanceAvailability}<br/>
    </p>`


export { pages_b2ccrm_analytics_cta } from "./en-US.js"

export { pages_b2ccrm_analytics_eyebrow } from "./en-US.js"

export { pages_b2ccrm_analytics_headline } from "./en-US.js"

export { pages_b2ccrm_analytics_logo } from "./en-US.js"

export { pages_b2ccrm_analytics_p1 } from "./en-US.js"

export { pages_b2ccrm_analytics_p2 } from "./en-US.js"

export { pages_b2ccrm_analytics_p3 } from "./en-US.js"

export { pages_b2ccrm_analytics_quote } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_title } from "./en-US.js"

export { pages_b2ccrm_description } from "./en-US.js"

export { pages_b2ccrm_hero_content_cta } from "./en-US.js"

export { pages_b2ccrm_hero_content_finally } from "./en-US.js"

export { pages_b2ccrm_hero_content_title } from "./en-US.js"

export { pages_b2ccrm_hero_rip_headline } from "./en-US.js"

export { pages_b2ccrm_hero_rip_instructions } from "./en-US.js"

export { pages_b2ccrm_introduction_eyebrow } from "./en-US.js"

export { pages_b2ccrm_introduction_headline } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_tag } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4_copy } from "./en-US.js"

export { pages_b2ccrm_marketing_cta } from "./en-US.js"

export { pages_b2ccrm_marketing_eyebrow } from "./en-US.js"

export { pages_b2ccrm_marketing_headline } from "./en-US.js"

export { pages_b2ccrm_marketing_logo } from "./en-US.js"

export { pages_b2ccrm_marketing_quote } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_title } from "./en-US.js"

export { pages_b2ccrm_nav_analytics } from "./en-US.js"

export { pages_b2ccrm_nav_marketing } from "./en-US.js"

export { pages_b2ccrm_nav_platform } from "./en-US.js"

export { pages_b2ccrm_nav_quiz } from "./en-US.js"

export { pages_b2ccrm_nav_service } from "./en-US.js"

export { pages_b2ccrm_nav_the_b2c_crm } from "./en-US.js"

export { pages_b2ccrm_nav_watch_demo } from "./en-US.js"

export { pages_b2ccrm_platform_cta } from "./en-US.js"

export { pages_b2ccrm_platform_eyebrow } from "./en-US.js"

export { pages_b2ccrm_platform_headline } from "./en-US.js"

export { pages_b2ccrm_platform_logo } from "./en-US.js"

export { pages_b2ccrm_platform_p1 } from "./en-US.js"

export { pages_b2ccrm_platform_p2 } from "./en-US.js"

export { pages_b2ccrm_platform_p3 } from "./en-US.js"

export { pages_b2ccrm_platform_stat } from "./en-US.js"

export { pages_b2ccrm_platform_stat_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_cta } from "./en-US.js"

export { pages_b2ccrm_quiz_eyebrow } from "./en-US.js"

export { pages_b2ccrm_quiz_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_subtext } from "./en-US.js"

export { pages_b2ccrm_service_cta } from "./en-US.js"

export { pages_b2ccrm_service_eyebrow } from "./en-US.js"

export { pages_b2ccrm_service_headline } from "./en-US.js"

export { pages_b2ccrm_service_logo } from "./en-US.js"

export { pages_b2ccrm_service_p2 } from "./en-US.js"

export { pages_b2ccrm_service_p3 } from "./en-US.js"

export { pages_b2ccrm_service_quote } from "./en-US.js"

export { pages_b2ccrm_service_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_service_quote_title } from "./en-US.js"

export { pages_b2ccrm_title } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_cdp = () => `Platform voor klantgegevens`


export { academy_courseStatus_registed } from "./en-US.js"

export { helpCenter_templates_search_results } from "./en-US.js"

export { organisms_forms_legal_agreeTermsLinkText } from "./en-US.js"

export { organisms_forms_legal_agreeToPartnerCodeOfConduct } from "./en-US.js"

export { organisms_forms_legal_agreeToTermsOfService } from "./en-US.js"

export { organisms_forms_legal_codeOfConduct_href } from "./en-US.js"

export { organisms_forms_legal_marketingCommunicationsConsent } from "./en-US.js"

export { organisms_pricing_plans_advance_data_platform_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_buttons_getDemo } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_headline } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_richTextBody } from "./en-US.js"

export { organisms_pricing_calculator_locales_BR } from "./en-US.js"